module.exports = __webpack_public_path__ + "img/rating-hero.778d4ee5.png";